import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import CBSelectField from '../shared/form_components/CBSelectField';
import { getStyle, TYPE_CARE_SERVICE } from '../../utils/utils';
import VehicleListView from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListView';
import { fetchVehiclesForCareService as _fetchVehiclesForCareService } from '../../actions/vehicleActions';
import { selectWorkshopChain as _selectWorkshopChain } from '../../actions/workshopActions';
import { assignWorkshopToVehicle as _assignWorkshopToVehicle } from '../../actions/chainActions';
import InviteToCareServiceModal from './components/InviteToCareServiceModal';

class CareServiceLayoutView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invitationModalIsOpen: false,
      agreementType: 'all',
    };
  }

  componentDidMount = () => {
    const { fetchVehiclesForCareService, selectedWorkshopId } = this.props;
  };

  componentDidUpdate(prevProps) {
    var { selectedWorkshopChainId, fetchVehiclesForCareService, selectedWorkshopId } = this.props;
    if (selectedWorkshopChainId !== prevProps.selectedWorkshopChainId && selectedWorkshopId && selectedWorkshopId === prevProps.selectedWorkshopId) {
      var params = { agreement_type: this.state.agreementType };
      if (selectedWorkshopChainId) {
        params.chain_id = selectedWorkshopChainId;
      }
      fetchVehiclesForCareService(selectedWorkshopId, params);
    }
  }

  onAgreementTypeChange = (changedObject) => {
    const { fetchVehiclesForCareService, selectedWorkshopId, selectedWorkshopChainId } = this.props;
    const newType = changedObject.value;
    this.setState({ agreementType: newType }, function () {
      var params = { agreement_type: newType };
      if (selectedWorkshopChainId) {
        params.chain_id = selectedWorkshopChainId;
      }
      fetchVehiclesForCareService(selectedWorkshopId, params);
    });
  };

  onChainFilterChange = (chainId) => {
    this.props.selectWorkshopChain(chainId);
  };

  render() {
    const {
      careServiceVehicles, selectedWorkshopId, selectedWorkshopChainId, fetchVehiclesForCareService, workshop, t,
    } = this.props;

    const { invitationModalIsOpen, agreementType } = this.state;

    var agreementTypeOptions = [
      { label: t('allAgreements'), value: 'all' },
      { label: t('workshopAgreement'), value: 'workshop' },
      { label: t('chainAgreement'), value: 'chain' },
    ];

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            {/* Sopimustyyppi filter hidden — "Näytä ketjun ajoneuvot" covers this */}
            <VehicleListView
              inviteToCareService={() => this.setState({ invitationModalIsOpen: true })}
              vehicles={careServiceVehicles}
              fetchVehicles={(params) => {
                var mergedParams = Object.assign({}, params, { agreement_type: agreementType });
                if (selectedWorkshopChainId) {
                  mergedParams.chain_id = selectedWorkshopChainId;
                }
                fetchVehiclesForCareService(selectedWorkshopId, mergedParams);
              }}
              listType={TYPE_CARE_SERVICE}
              selectedWorkshopChainId={selectedWorkshopChainId}
              onChainFilterChange={this.onChainFilterChange}
              assignWorkshopToVehicle={this.props.assignWorkshopToVehicle}
              currentWorkshopId={workshop ? workshop.id : null}
              currentWorkshopName={workshop ? workshop.name : ''}
            />
            {
              invitationModalIsOpen && (
                <InviteToCareServiceModal
                  modalIsOpen={invitationModalIsOpen}
                  selectedWorkshopId={selectedWorkshopId}
                  closeModal={() => this.setState({ invitationModalIsOpen: false })}
                />
              )
            }
          </div>

        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    filterRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      gap: 16,
    },
    filterLabel: {
      fontSize: 13,
      color: '#333',
      marginRight: 8,
    },
    filterSelect: {
      backgroundColor: '#ebebeb',
      fontSize: 13,
      color: 'black',
      borderRadius: 100,
      height: 36,
      border: 'none',
      width: 220,
      textAlignLast: 'center',
      textAlign: 'center',
    },
  },
};

function mapStateToProps(state) {
  return {
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedWorkshopChainId: state.workshop.selectedWorkshopChainId,
    careServiceVehicles: state.vehicle.careServiceVehicles,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchVehiclesForCareService: _fetchVehiclesForCareService,
    selectWorkshopChain: _selectWorkshopChain,
    assignWorkshopToVehicle: _assignWorkshopToVehicle,
  },
)(translate('CareServiceLayoutView')(CareServiceLayoutView));
